export default "__VITE_ASSET__o$paPlVO__"